import SharedPropsService from '../SharedPropsService';
import { getScreenType } from '../configs/platfom-utils';
import { Dimensions, Platform } from 'react-native';
import { SCREEN_SIZE } from '@voltmoney/types';
import DeviceInfo from 'react-native-device-info';
import CryptoJS from 'react-native-crypto-js';
import { initializeApp } from "firebase/app";
import { fetchAndActivate, getRemoteConfig } from "firebase/remote-config";
import sharedPropsService from "../SharedPropsService";
export const __isTest__ = false;
export const __isMock__ = false;
export const screenType = getScreenType(Dimensions.get('window').width);
export const defaultHeaders = async () => {
    const headers = new Headers();
    headers.append('X-AppMode', 'INVESTOR_VIEW');
    headers.append('X-AppPlatform', await SharedPropsService.getAppPlatform());
    headers.append('Authorization', `Bearer ${await SharedPropsService.getToken()}`);
    headers.append('Content-Type', 'application/json');
    headers.append('Encryption', SharedPropsService.getBuildType().endsWith('PRODUCTION')
        ? 'true'
        : 'false');
    if (screenType === SCREEN_SIZE.X_SMALL ||
        screenType === SCREEN_SIZE.SMALL) {
        headers.append('X-DeviceType', 'Mobile');
    }
    else {
        headers.append('X-DeviceType', 'Desktop');
    }
    return headers;
};
export const getAuthHeaders = async () => ({
    'X-EntityType': 'BORROWER',
    'X-AppPlatform': await SharedPropsService.getAppPlatform(),
    'Content-Type': 'application/json',
    Encryption: SharedPropsService.getBuildType().endsWith('PRODUCTION')
        ? 'true'
        : 'false',
    'X-DeviceType': screenType === SCREEN_SIZE.X_SMALL || screenType === SCREEN_SIZE.SMALL
        ? await DeviceInfo.getModel()
        : 'Desktop',
});
// @ts-ignore
export const getUniqueDeviceId = async () => {
    try {
        const uniqueId = await DeviceInfo.getUniqueId();
        return uniqueId;
    }
    catch (err) {
        return "";
    }
};
export const getDeviceName = () => {
    return DeviceInfo.getBrand();
};
export const getAppHeader = async () => ({
    'X-AppMode': 'INVESTOR_VIEW',
    'X-DeviceId': Platform.OS === 'web' ? '' : await getUniqueDeviceId(),
    'X-AppPlatform': await SharedPropsService.getAppPlatform(),
    'X-AppVersion': Platform.OS === 'web' ? '' : DeviceInfo.getVersion(),
    Authorization: `Bearer ${await SharedPropsService.getToken()}`,
    'Content-Type': 'application/json',
    Encryption: SharedPropsService.getBuildType().endsWith('PRODUCTION')
        ? 'true'
        : 'false',
    'X-DeviceType': screenType === SCREEN_SIZE.X_SMALL || screenType === SCREEN_SIZE.SMALL
        ? DeviceInfo.getModel()
        : 'Desktop',
});
export const getPartnerAuthHeaders = () => ({
    'X-EntityType': 'PARTNER',
    'X-AppPlatform': __isTest__ ? 'VOLT_MOBILE_APP_TEST' : 'VOLT_MOBILE_APP',
    'Content-Type': 'application/json',
});
export const APP_CONFIG = {
    POLLING_INTERVAL: 5000,
    AUTO_REDIRECT: 5000,
    MODAL_TRIGGER_TIMEOUT: 250,
    POP_UP_SIZE: {
        WIDTH: 600,
        HEIGHT: 600,
    },
};
export var AssetRepositoryType;
(function (AssetRepositoryType) {
    AssetRepositoryType["CAMS"] = "CAMS";
    AssetRepositoryType["KARVY"] = "KARVY";
    AssetRepositoryType["MFCENTRAL"] = "MFCENTRAL";
})(AssetRepositoryType || (AssetRepositoryType = {}));
export var CreditApplicationType;
(function (CreditApplicationType) {
    CreditApplicationType["CREDIT_AGAINST_SECURITIES_BORROWER"] = "CREDIT_AGAINST_SECURITIES_BORROWER";
    CreditApplicationType["CREDIT_AGAINST_SECURITIES_PARTNER"] = "CREDIT_AGAINST_SECURITIES_PARTNER";
    CreditApplicationType["CREDIT_MODIFICATION_AGAINST_SECURITIES"] = "CREDIT_MODIFICATION_AGAINST_SECURITIES";
    CreditApplicationType["CREDIT_MODIFICATION_MARGIN_CALL_AGAINST_SECURITIES"] = "CREDIT_MODIFICATION_MARGIN_CALL_AGAINST_SECURITIES";
    CreditApplicationType["CREDIT_RENEWAL_AGAINST_SECURITIES"] = "CREDIT_RENEWAL_AGAINST_SECURITIES";
})(CreditApplicationType || (CreditApplicationType = {}));
export const PartnerAssetRepositoryMap = {
    [AssetRepositoryType.CAMS]: {
        value: AssetRepositoryType.CAMS,
        NAME: 'Cams',
        OTP_LENGTH: 4,
        LIST: [],
    },
    [AssetRepositoryType.KARVY]: {
        VALUE: AssetRepositoryType.KARVY,
        NAME: 'karvy',
        OTP_LENGTH: 5,
        LIST: [],
    },
};
export const AssetRepositoryMap = new Map([
    [
        AssetRepositoryType.CAMS,
        {
            value: AssetRepositoryType.CAMS,
            NAME: 'CAMS',
            OTP_LENGTH: 5,
            LIST: [],
            isDisabled: false,
            MODE_OF_COMM: 'email',
            PRIORITY: 2,
            IS_PLEDGED: false,
        },
    ],
    [
        AssetRepositoryType.KARVY,
        {
            VALUE: AssetRepositoryType.KARVY,
            NAME: 'K-Fintech',
            OTP_LENGTH: 6,
            LIST: [],
            isDisabled: false,
            MODE_OF_COMM: 'phone',
            PRIORITY: 1,
            IS_PLEDGED: false,
        },
    ],
    [
        AssetRepositoryType.MFCENTRAL,
        {
            VALUE: AssetRepositoryType.KARVY,
            NAME: 'MFCentral',
            OTP_LENGTH: 6,
            LIST: [],
            isDisabled: false,
            MODE_OF_COMM: 'phone',
            PRIORITY: 3,
            IS_PLEDGED: false,
        },
    ],
]);
export const AssetRepositoryTitle = new Map([
    [
        AssetRepositoryType.CAMS,
        {
            value: "CAMS",
        },
    ],
    [
        AssetRepositoryType.KARVY,
        {
            value: "KFINTECH",
        },
    ],
    [
        AssetRepositoryType.MFCENTRAL,
        {
            value: "MFCentral",
        },
    ],
]);
export const getPrimaryAssetRepository = async () => {
    let config = await SharedPropsService.getFirebaseConfig()?.rta_priority;
    console.warn("CONFIG RECEIVED IS", config);
    const [priorityMap] = new Map([...AssetRepositoryMap.entries()].sort((a, b) => config === AssetRepositoryType.CAMS ? b[1].PRIORITY - a[1].PRIORITY : a[1].PRIORITY - b[1].PRIORITY));
    return priorityMap[0];
};
export const getPrimaryAssetRepositoryForPledge = async () => {
    const [priorityMap] = new Map([...AssetRepositoryMap.entries()].sort((a, b) => b[1].PRIORITY - a[1].PRIORITY));
    return priorityMap[0];
};
export var RegexConfig;
(function (RegexConfig) {
    RegexConfig["EMAIL"] = "^^[a-zA-Z0-9._{|}-]*@[a-zA-Z0-9]+.^[A-Za-z]+${2,}$";
    RegexConfig["MOBILE"] = "^[0-9]*$";
    RegexConfig["NEW_MOBILE"] = "^[0-9]{10}$";
    RegexConfig["PAN"] = "^[A-Z]{5}[0-9]{4}[A-Z]{1}$";
    RegexConfig["AADHAR"] = "^[2-9]{1}[0-9]{11}$";
    RegexConfig["ONLY_NUMBER"] = "^[0-9]*$";
    RegexConfig["NEW_EMAIL"] = "^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$";
    RegexConfig["IFSC"] = "^[A-Z]{4}0[A-Z0-9]{6}$";
    RegexConfig["SPECIAL_CHARACTERS"] = "^[A-Za-z ]+$";
})(RegexConfig || (RegexConfig = {}));
export var DeepLinks;
(function (DeepLinks) {
    DeepLinks["MOBILE_WHATSAPP"] = "whatsapp://send?phone=";
    DeepLinks["WHATSAPP"] = "https://wa.me/";
    DeepLinks["CALL"] = "tel:";
    DeepLinks["MAILTO"] = "mailto:";
})(DeepLinks || (DeepLinks = {}));
export var ConnectionTypes;
(function (ConnectionTypes) {
    ConnectionTypes["CALL"] = "CALL";
    ConnectionTypes["GROUP_WHATSAPP"] = "GROUP_WHATSAPP";
    ConnectionTypes["WHATSAPP"] = "WHATSAPP";
})(ConnectionTypes || (ConnectionTypes = {}));
export var ConfigTokens;
(function (ConfigTokens) {
    ConfigTokens["IS_PAN_EDIT_ALLOWED"] = "IS_PAN_EDIT_ALLOWED";
    ConfigTokens["IS_RTA_SWITCH_ENABLED"] = "IS_RTA_SWITCH_ENABLED";
    ConfigTokens["IS_MF_FETCH_AUTO_TRIGGER_OTP"] = "IS_MF_FETCH_AUTO_TRIGGER_OTP";
    ConfigTokens["IS_KYC_PHOTO_VERIFICATION"] = "IS_KYC_PHOTO_VERIFICATION";
    ConfigTokens["IS_MF_FETCH_BACK_ALLOWED"] = "IS_MF_FETCH_BACK_ALLOWED";
    ConfigTokens["MIN_AMOUNT_ALLOWED"] = "MIN_AMOUNT_ALLOWED";
    ConfigTokens["MAX_AMOUNT_ALLOWED"] = "MAX_AMOUNT_ALLOWED";
    ConfigTokens["IS_FIRST_JOURNEY"] = "IS_FIRST_JOURNEY";
})(ConfigTokens || (ConfigTokens = {}));
export var ConfigValues;
(function (ConfigValues) {
    ConfigValues[ConfigValues["MinimumAmountAllowed"] = 25000] = "MinimumAmountAllowed";
    ConfigValues["AADHAR"] = "^[2-9]{1}[0-9]{11}$";
})(ConfigValues || (ConfigValues = {}));
export const encrypt = async (text) => {
    if (!text) {
        return '';
    }
    const ivMaterial = 'globalaesvectors';
    const keyMaterial = 'jXn2r5u8x/A?D(G+KbPeSgVkYp3s6v9y';
    let key = CryptoJS.enc.Utf8.parse(keyMaterial);
    let iv = CryptoJS.enc.Utf8.parse(ivMaterial);
    let ciphertext1 = CryptoJS.AES.encrypt(text, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
    }); // default values: CBC, PKCS#7 padding
    return CryptoJS.enc.Base64.stringify(ciphertext1.ciphertext);
};
export const decrypt = async (text) => {
    if (!text) {
        return '';
    }
    text = text.replace('-', '+').replace('_', '/');
    const decodedText = CryptoJS.enc.Base64.parse(text);
    const ivMaterial = 'globalaesvectors';
    const keyMaterial = 'G-KaPdSgVkYp3s5v8y/B?E(H+MbQeThW';
    let key = CryptoJS.enc.Utf8.parse(keyMaterial);
    let iv = CryptoJS.enc.Utf8.parse(ivMaterial);
    let ciphertext1 = CryptoJS.AES.decrypt({
        ciphertext: decodedText,
    }, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
    }); // default values: CBC, PKCS#7 padding
    const result = CryptoJS.enc.Utf8.stringify(ciphertext1);
    return result;
};
export const isEncrypted = (url) => {
    if (url.startsWith('https://api.voltmoney.in')) {
        return true;
    }
    else {
        return false;
    }
};
export const getParametersInUtils = (url) => {
    const params = {};
    let paramString = url.split('?')[1];
    let queryString = (Platform.OS === 'web') ? new URLSearchParams(paramString) : new Map();
    for (let pair of queryString.entries()) {
        params[pair[0].includes('/') ? pair[0].split('/')[1] : pair[0]] =
            pair[1].includes('/') ? pair[1].split('/')[0] : pair[1];
    }
    return params;
};
export const isDarkModeTheme = () => {
    if (Platform.OS === 'web') {
        let params = getParametersInUtils(window?.location?.href);
        // @ts-ignore
        let isDarkMode = params?.isDarkMode;
        return isDarkMode;
    }
    return false;
};
export const initializeFirebase = async () => {
    const is_fire_base_initialized = await sharedPropsService.getIsFireBaseInitialized();
    if (Platform.OS === 'web' && (is_fire_base_initialized === false)) {
        const firebaseConfig = {
            apiKey: "AIzaSyCqsCPKr9UpZF-VeNS9hX4OXp3oF5DAhik",
            authDomain: "volt-web-app.firebaseapp.com",
            projectId: "volt-web-app",
            storageBucket: "volt-web-app.appspot.com",
            messagingSenderId: "200598813164",
            appId: "1:200598813164:web:adc6c7ddfb7bdad0c0a8c9",
            measurementId: "G-WSGQFFRFN3"
        };
        const app = await initializeApp(firebaseConfig);
        const remoteConfig = await getRemoteConfig(app);
        remoteConfig.settings.minimumFetchIntervalMillis = 10000;
        try {
            await fetchAndActivate(remoteConfig);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            if (remoteConfig?._storageCache?.activeConfig) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                //@ts-ignore
                await SharedPropsService.setFirebaseConfig(remoteConfig?._storageCache?.activeConfig);
                await sharedPropsService.setIsFireBaseInitialized(true);
            }
        }
        catch (error) {
            // Handle any errors that occur during fetching and activation
            console.error("Error fetching and activating remote config:", error);
        }
    }
};
